{
    "raporsatiskalangun": {
        "Baslik": "Verkoop Resterende Dagen Rapport",
        "PoliceNo": "Polisnr",
        "Musteri": "Klant",
        "Urun": "Product",
        "Kullanici": "Gebruiker",
        "KalanGun": "Resterende Dagen",
        "VadeTarihi": "Vervaldatum",
        "OdemeSekli": "Betalingswijze",
        "Ara": "Filter",
        "A1": "Maandelijks (< 7 Dagen)",
        "A3": "Kwartaal (< 15 Dagen)",
        "A6": "Zes Maandelijks (< 23 Dagen)",
        "A12": "Jaarlijks (< 31 Dagen)",
        "Kapsam": "Bereik"
    }
}
